import styled from "styled-components";
import theme from "~/styles/theme";

export const ContentHolder = styled.div`
  text-align: center;
  p {
    color: ${(props) =>
      props.success ? theme.palette.brand.primary.key : theme.palette.feedback.error.key};
  }
  button {
    width: 100%;
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 560px;
    margin: 0 auto;
    button {
      width: 245px;
      padding: 14px 26px;
    }
  }
`;
